import Common from '../Common';

const Communicator = class extends Common {
	async download(brandingName: string, communicatorVersion: string, communicatorPlatform: string, communicatorOs: string) {
		return this.get(`/communicator/${brandingName}/${communicatorVersion}/x86/${communicatorPlatform}/${communicatorOs}`)
	}

	async versions(brandingName: string, communicatorVersion: string, communicatorPlatform: string, communicatorOs: string) {
		return this.get(`/communicator/${brandingName}/${communicatorVersion}/x86/${communicatorPlatform}/${communicatorOs}/versions`)
	}

	async changelog(brandingName: string, communicatorVersion: string, communicatorPlatform: string, communicatorOs: string) {
		return this.get(`/communicator/${brandingName}/${communicatorVersion}/x86/${communicatorPlatform}/${communicatorOs}/changelog`)
	}
}

export default Communicator;
